import React from "react";
import ReactDOM from "react-dom";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import * as serviceWorker from "./serviceWorker";
import User from "./User";
import AppErrorBoundary from "./components/AppErrorBoundary";
import useAxios from "axios-hooks";
import { ThemeProvider as Chakra } from "@chakra-ui/core";
import { API_URL } from "./config";

const GlobalStyle = createGlobalStyle`
  /* More Font Awesome configuration */
  
    @font-face {
      font-family: 'uniform-black';
      src: url('/MillerTypeFoundry-UniformBlack.otf') format('opentype');
    }
    html {
      font-family: 'uniform-black', sans-serif;
      box-sizing: border-box;
   
    }
    *, *:before, *:after{
      box-sizing: inherit;
    }
    body{
      padding: 0;
      margin: 0;
    }
    button{
      cursor: pointer;
      border: none;
      font-family: 'uniform-black', sans-serif;
      &:focus {
      outline: none;
    }
    }
    input{
      font-family: sans-serif;
      font-size: 18px;
    }
    h1, h2, h3, h4, h5, h6 {
      margin: 0;
    }
    h2 {
      font-size: 46px;
      @media (max-width: ${(props) => props.theme.breakPoints.tablet}){
        font-size: 36.8px;
      }
      @media (max-width: ${(props) => props.theme.breakPoints.mobile}){
        font-size: 34.5px;
      }
    }
    a {
      text-decoration: none;
      color: black;
    }
    video {
    &:focus {
      outline: none;
    }
  }
    .standardCopy {
      font-family: 'Roboto', sans-serif;
      line-height: 1.5rem;
      font-size: 18px;
    } 
    .whiteBG{
      background: white;
      color: black
    }
    .blueBG{
      background: ${(props) => props.theme.primaryBlue};
      color: white;
    }

    .primaryLink{
      cursor: pointer;
    display: inline-block;
    text-align: center;
    border-radius: 4px;
    padding: 23px 50px;
    opacity: 1;
    text-decoration: none;
    font-size: 18px;
    position: relative;
    transition: all 300ms ease;
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      padding: 23px 35px;
      width: 100%;
    }
    &:hover {
      transform: translateY(-3px);
      &::after{
        opacity: 1;
      }
    }
    &::after{
      content: "";
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 300ms ease;
    box-shadow: 0 20px 38px rgba(0, 0, 0, 0.16);
    }
    &:active{
      transform: translateY(1px);
    }

    }
`;

const theme = {
  primaryBlue: "#029DC3",
  purple: "rgb(234, 241, 253)",
  lightGrey: "rgba(0, 0, 0, 0.04)",
  darkGrey: "#454545",
  maxWidth: "1100px",
  buttonBorderRadius: "4px",
  boxShadow: "0 20px 38px rgba(0, 0, 0, 0.16)",
  buttonTransform: "translateY(-3px)",
  breakPoints: {
    tablet: "1000px",
    mobile: "665px",
  },
  contentWidth: {
    desktop: "1200px",
    tablet: "600px",
    mobile: "320px",
  },
};

const App = () => {
  const [
    { loading: userLoading, data: userData, error: userError },
    refetchUser,
  ] = useAxios({
    url: `${API_URL}/getMe`,
    method: "GET",
    withCredentials: true,
  });
  if (userError) return <div>{userError}</div>;

  return (
    <AppErrorBoundary>
      <Chakra>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <User
            userData={userData}
            userLoading={userLoading}
            userError={userError}
            refetchUser={refetchUser}
          />
        </ThemeProvider>
      </Chakra>
    </AppErrorBoundary>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
